import { withInstall } from '../utils'
import _Tags from './Tags'
import './index.scss'

export const Tags = withInstall(_Tags)
export default Tags
